export const declinedApprovalSharedDesignsApiPageSelector = (state, page) => {
  return state.api.designs.personal.approvals.declinedShared.pages[page];
};

export const declinedApprovalSharedDesignsApiSelector = (state, page) => {
  return state.api.designs.personal.approvals.declinedShared;
};
